import React from "react";
import { useSelector } from "react-redux";
import {
  getQuestionsAndAnswers,
  selectAppraisal
} from "../../../store/selectors";
import useRadioAndToolTipQuestionCompact from "../hooks/useRadioAndToolTipQuestionCompact";
import { AnswerTooltip } from "../../ConditionQuestions/components/AnswerTooltip";
import DropdownQuestion from "../../../components/DropdownQuestion/DropdownQuestion";

interface RadioAndToolTipQuestionCompactProps {
  question: Question;
  factualQuestion?: boolean;
  replaceManufacturerName?: boolean;
}

export const RadioAndToolTipQuestionCompact = ({
  question,
  factualQuestion = false,
  replaceManufacturerName = false
}: RadioAndToolTipQuestionCompactProps) => {
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const storedAnswer = questionsAndAnswers && questionsAndAnswers[question.id];
  const { conditionalAnswersSubmitted } = useSelector(selectAppraisal);

  const {
    handleChange,
    groupName,
    questionString,
    sortedAnswers,
    tooltipWidth,
    answerTooltip,
    setAnswerTooltip,
    selectedOption,
    setSelectedOption
  } = useRadioAndToolTipQuestionCompact({ question, replaceManufacturerName });
  
  const isAnswerSubmitted = conditionalAnswersSubmitted.includes(question.id);
  const radioError = !storedAnswer && isAnswerSubmitted;

  return (
    <>
      <p className="ch-width--12 ch-form__control-label ch-mb--2">
        {questionString}
      </p>
      {factualQuestion ||
      question.metadata?.inputComponent?.toLowerCase() ===
        "RadioTooltip".toLowerCase() ? (
        <>
          {radioError && (
            <div className="ch-form__group ch-form__group--error ch-mb--0">
              <span className="ch-form__control-validation ch-mb--1">
                Please choose an option
              </span>
            </div>
          )}
          <div className="ch-form__group sl:ch-display--flex ch-flex-direction--column sl:ch-flex-flow--row-wrap lg:ch-flex-flow--row-nowrap sm:ch-justify-content--start">
            {sortedAnswers.map((answerObject: any, index: number) => (
              <div key={answerObject.id}>
                <div className="ch-mb--3">
                  <input
                    id={`${answerObject.label}`}
                    data-testid={`factQ-test-id-${answerObject.id}`}
                    type="radio"
                    name={`${groupName}-option`}
                    className="ch-radio"
                    checked={
                      selectedOption
                        ? selectedOption[0] === answerObject.id
                        : false
                    }
                    onChange={() => {
                      handleChange(parseInt(answerObject.id));
                      setSelectedOption([answerObject.id]);
                      setAnswerTooltip(answerObject.tooltip || "");
                    }}
                  />
                  <label
                    htmlFor={`${answerObject.label}`}
                    className={`ch-radio__label ch-radio__label--primary ch-mr--2 ch-width--12 sl:ch-width--auto`}
                  >
                    {answerObject.label}
                  </label>
                </div>
                {selectedOption && answerObject.id === selectedOption[0] && (
                  <div className="ch-mv--2 ch-display--block sl:ch-display--none">
                    <AnswerTooltip content={answerTooltip} />
                  </div>
                )}
              </div>
            ))}
          </div>
          {selectedOption && (
            <div
              className="ch-mt--2 ch-display--none sl:ch-display--block"
              style={{ width: `${tooltipWidth}px` }}
            >
              <AnswerTooltip content={answerTooltip} />
            </div>
          )}
        </>
      ) : (
        <DropdownQuestion
          id={`${question.id}`}
          labelText=""
          name={`${question.id}`}
          defaultValue={storedAnswer}
          defaultOptionText="Select an option"
          onChange={(event) => handleChange(parseInt(event.target.value))}
          options={sortedAnswers}
          validationMessage={radioError ? "Select an option" : null}
        />
      )}
    </>
  );
};
